import DialogComponent from "components/Dialog";

export default class AddTratPlanDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            title: "",
            doctorId: null,
            workItemId: null,
        };

        this.state = { ...this.defaultState };
    }

    async show(clientInfo, info, hideCb) {
        this.dialogTitle = info?.id ? "treatmentPlan.editDialog" : "treatmentPlan.newDialog";

        if (info) {
            const { title, doctorId, workItemId } = info;

            this.state.title = title || "";
            this.state.doctorId = doctorId || null;
            this.state.workItemId = workItemId || null;
        }

        this.info = info;
        this.hidCb = hideCb;

        this.visits = await this.getClientVisists(clientInfo?.id, false, true);

        super.show();
    }

    onShow() {
        const { title } = this.state;

        if (title)
            this.titleNode.value = title;
    }

    async save() {
        const { title, doctorId, workItemId } = this.state;

        if (!title || !doctorId)
            return;

        this.hide();

        const id = this.info?.id || null;

        if (this.hidCb?.apply)
            this.hidCb({ title, workItemId, doctorId, id });
    }

    renderContent() {
        const { workItemId, doctorId } = this.state;

        return (
            <div className="content flex col gap16" style={{ width: "650px" }}>
                {this.insertInput({
                    ref: el => this.titleNode = el,
                    label: "main.name",
                    placeHolder: "main.name",
                    onChange: this.changeState.bind(this, "title")
                })}
                <div className="content flex gap24">
                    <div className="flex1">
                        {this.insertSelectVisit({
                            value: workItemId,
                            label: "treatmentPlan.linkToVisit",
                            items: this.visits,
                            onChange: this.changeState.bind(this, "workItemId")
                        })}
                    </div>
                    <div className="flex1">
                        {this.insertSelectDoctor({
                            value: doctorId,
                            label: "client.doctor",
                            onClick: this.changeState.bind(this, "doctorId")
                        })}
                    </div>
                </div>
            </div>
        );
    }
}
